import {
	gridHTML,
	menuToolBar,
	flow,
	columnHeaderHTML,
	maskHTML,
	colsmenuHTML,
	rightclickHTML,
	inputHTML,
	filtermenuHTML,
	filtersubmenuHTML,
	sheetconfigHTML,
} from '../controllers/constant';
import luckysheetConfigsetting from '../controllers/luckysheetConfigsetting';
import luckysheetPostil from '../controllers/postil';
import {
	datagridgrowth
} from './getdata';
import editor from './editor';
import rhchInit from './rhchInit';
import {
	replaceHtml
} from '../utils/util';
import Store from '../store';
import locale from '../locale/locale';

export default function luckysheetcreatedom(colwidth, rowheight, data, menu, title) {
	// //最少30行
	// if(rowheight < 30){
	//     rowheight = 30;
	// }

	// //最少22列
	// if(colwidth < 22){
	//     colwidth = 22;
	// }

	let gh = gridHTML();
	gh = replaceHtml(gh, {
		"logotitle": title
	}); //设置title
	gh = replaceHtml(gh, {
		"menu": menuToolBar()
	}); //设置需要显示的菜单

	let flowHTML = flow;
	if (Store.config == null) {
		Store.config = {};
	}

	rhchInit(rowheight, colwidth);
	const printset = JSON.parse(Store.printset);
	const _locale = locale();
	const locale_info = _locale.info;
	let addControll = '<button id="luckysheet-bottom-add-row" class="btn btn-default">' + locale_info.add +
		'</button><input id="luckysheet-bottom-add-row-input" type="text" class="luckysheet-datavisual-config-input luckysheet-mousedown-cancel" placeholder="' +
		(luckysheetConfigsetting.addRowCount || 100) + '"><span style="font-size: 14px;">' + locale_info.row +
		'</span><span style="font-size: 14px;color: #9c9c9c;">(' + locale_info.addLast + ')</span>';
	let backControll = ' <button id="luckysheet-bottom-bottom-top" class="btn btn-default" style="">' + locale_info
		.backTop + '</button>';
	// let pageControll = ' <span id="luckysheet-bottom-page-info" style="font-size: 14px;color: #f34141;">共'+ luckysheetConfigsetting.pageInfo.totalPage +'页，当前已显示'+ (luckysheetConfigsetting.pageInfo.currentPage) +'页，每页'+ luckysheetConfigsetting.pageInfo.pageSize +'条</span> <button id="luckysheet-bottom-page-next" class="btn btn-danger" style="">下一页</button>';
	let pageInfo = replaceHtml(locale_info.pageInfo, {
		total: luckysheetConfigsetting.total ? luckysheetConfigsetting.total : "",
		totalPage: luckysheetConfigsetting.pageInfo.totalPage ? luckysheetConfigsetting.pageInfo.totalPage : "",
		currentPage: luckysheetConfigsetting.pageInfo.currentPage ? luckysheetConfigsetting.pageInfo
			.currentPage : "",
	});
	let pageControll = ' <span id="luckysheet-bottom-page-info" style="font-size: 14px;color: #f34141;">' + pageInfo +
		'</span> <button id="luckysheet-bottom-page-next" class="btn btn-danger" style="">下一页</button>';
	let pageControll2 = ' <span id="luckysheet-bottom-page-info" style="font-size: 14px;color: #f34141;">' + pageInfo +
		'</span>';
	//页眉页脚
	let printControll = '';
	let printHeader = Store.printHeader;
	if (printHeader == true) {
		printControll = '<div class="print-body">' +
			'<div class="print-page" style="width:' + printset.pageWidth + 'mm; height:' + printset.pageHeight +
			'mm;">' +
			'<div class="row header-row" style="top: 18.8976px; padding-left: 67.2756px; padding-right: 67.2756px;">';

		for (let i = 0; i < Store.printHeaderContent.length; i++) {
			if (i == 0) {
				printControll +=
					'<div class="fx-print-hf-cell ff-SimSun font-size-10 htLeft vtMiddle selectedluck" style="color: rgb(0, 0, 0); font-style: normal; font-weight: normal; max-height: 280px;">' +
					'<div class="data">' + Store.printHeaderContent[i].content + '</div>' +
					'<div class="data-placeholder"></div>' +
					'</div>';
			} else {
				printControll +=
					'<div class="fx-print-hf-cell ff-SimSun font-size-10 htLeft vtMiddle" style="color: rgb(0, 0, 0); font-style: normal; font-weight: normal; max-height: 280px;">' +
					'<div class="data">' + Store.printHeaderContent[i].content + '</div>' +
					'<div class="data-placeholder"></div>' +
					'</div>';
			}

		}

		printControll += '</div>' +

			'<div  class="content-table" style="top:' + printset.paddingTop + 'mm; bottom:' + printset.paddingBottom +
			'mm; padding-left:' + printset.paddingLeft + 'mm; padding-right:' + printset.paddingRight +
			'mm;background-color: #c2c2c2; opacity:0.3;">';
		// '<table data-type="luckysheet_copy_action_table" style="width:100%;height:100%">' +
		// '<colgroup width="72px">' +
		// '</colgroup>' +
		// '<colgroup width="72px">' +
		// '</colgroup>' +
		// '<tr>' +
		// '<td style="height:19px;">' +
		// 'value1' +
		// '</td>' +
		// '<td style="">' +
		// 'value3' +
		// '</td>' +
		// '</tr>' +
		// '<tr>' +
		// '<td style="height:19px;">' +
		// 'value2' +
		// '</td>' +
		// '<td style="">' +
		// 'value4' +
		// '</td>' +
		// '</tr>' +
		// '</table>';
		if (Store.printHeaderTableHtml != undefined) {
			printControll += Store.printHeaderTableHtml;
		}

		printControll += '</div>' +


			'<div class="rowfoot header-row" style="bottom: 18.8976px; padding-left: 67.2756px; padding-right: 67.2756px;">';
		for (let i = 0; i < Store.printFooterContent.length; i++) {

			printControll +=
				'<div class="fx-print-hf-cell ff-SimSun font-size-10 htLeft vtMiddle" style="color: rgb(0, 0, 0); font-style: normal; font-weight: normal; max-height: 280px;">' +
				'<div class="data">' + Store.printFooterContent[i].content + '</div>' +
				'<div class="data-placeholder"></div>' +
				'</div>'



		}

		' </div>' +
		'</div>';
	}




	let bottomControll = "";
	if (luckysheetConfigsetting.enableAddRow) {
		bottomControll += addControll;
	}

	if (luckysheetConfigsetting.enablePage) {
		if (parseInt(luckysheetConfigsetting.pageInfo.totalPage) == 1) {
			bottomControll += pageControll2;
		} else {
			bottomControll += pageControll;
		}
	}

	if (luckysheetConfigsetting.enableAddBackTop) {
		bottomControll += backControll;
	}
	let width = "210";
	let height = "297"
	let flowstr=""
	if(Store.headerTitleContent==undefined)
	{
		 flowstr = replaceHtml(
			'<div id="luckysheetcoltable_0" class="luckysheet-cell-flow-col" style="background-color:#fff"> <div id ="luckysheet-sheettable_0" class="luckysheet-cell-sheettable" style="height:${height}px;width:${width}px;"><div id="luckysheet-sheettheight" style="border:1px dashed #889cfd; margin-left:0px;padding:0px;position:absolute;width:100%;left: 0px;top:' +
			mmToPx(height) +
			'mm;z-index:800;"></div> <div id="luckysheet-sheettwidth" style="border:1px dashed #889cfd; margin-left:' +
			mmToPx(width) +
			'mm;padding:0px;position:absolute;height:100%;left: 0px;top:0px;z-index:800;"></div></div><div id="luckysheet-bottom-controll-row" class="luckysheet-bottom-controll-row"> ' +
			bottomControll + ' </div> </div>', {
				"height": Store.rh_height,
				"width": Store.ch_width - 1
			});
	}
	else{
		 flowstr = replaceHtml('<div id="luckysheetcoltable_0" class="luckysheet-cell-flow-col" style="background-color:#fff"> <div id ="luckysheet-sheettable_0" class="luckysheet-cell-sheettable" style="height:${height}px;width:${width}px;"></div><div id="luckysheet-bottom-controll-row" class="luckysheet-bottom-controll-row"> '+ bottomControll +' </div> </div>', { "height": Store.rh_height, "width": Store.ch_width - 1 });
		
	}
	
	

	let colsheader = replaceHtml(columnHeaderHTML, {
		"width": Store.ch_width,
		"index": 0,
		"column": ""
	});
	let printControllheader = "";
	if (Store.printHeader == true) {
		{
			printControllheader = replaceHtml(printControll, {
				"width": '1000px',
				"index": 0,
				"column": ""
			});
		}
	}

	flowHTML = replaceHtml(flowHTML, {
		"width": Store.ch_width,
		"flow": flowstr,
		"index": 0
	});

	gh = replaceHtml(gh, {
		"flow": flowHTML,
		"rowHeader": "<div style='height:" + Store.rh_height +
			"px' id='luckysheetrowHeader_0' class='luckysheetsheetchange'></div>",
		"columnHeader": colsheader,
		"functionButton": luckysheetConfigsetting.functionButton
	}); //设置需要显示的菜单

	$("#" + Store.container).append(gh);

	$("#luckysheet-scrollbar-x div").width(Store.ch_width);
	$("#luckysheet-scrollbar-y div").height(Store.rh_height + Store.columnHeaderHeight - Store
		.cellMainSrollBarSize -
		3);

	//新建行菜单
	$("body").append(maskHTML);
	$("body").append(colsmenuHTML);
	$("body").append(rightclickHTML());
	$("body").append(inputHTML);
	$("body").append(replaceHtml(filtermenuHTML(), {
		"menuid": "filter"
	}));
	$("body").append(replaceHtml(filtersubmenuHTML(), {
		"menuid": "filter"
	}));
	$("body").append(sheetconfigHTML());

	$("#luckysheet-rows-h").width((Store.rowHeaderWidth - 1.5));
	$("#luckysheet-cols-h-c").height((Store.columnHeaderHeight - 1.5));
	$("#luckysheet-left-top").css({
		width: Store.rowHeaderWidth - 1.5,
		height: Store.columnHeaderHeight - 1.5
	});
	$("#" + Store.container).append(printControllheader); //页眉页脚
	// //批注
	// luckysheetPostil.buildAllPs(Store.flowdata);

	$("#luckysheet_info_detail_input").val(luckysheetConfigsetting.title);


}

export function getDPI() {
	var arrDPI = new Array;
	if (window.screen.deviceXDPI) {
		arrDPI[0] = window.screen.deviceXDPI;
		arrDPI[1] = window.screen.deviceYDPI;
	} else {
		var tmpNode = document.createElement("DIV");
		tmpNode.style.cssText = "width:1in;height:1in;position:absolute;left:0px;top:0px;z-index:99;visibility:hidden";
		document.body.appendChild(tmpNode);
		arrDPI[0] = parseInt(tmpNode.offsetWidth);
		arrDPI[1] = parseInt(tmpNode.offsetHeight);
		tmpNode.parentNode.removeChild(tmpNode);
	}
	return arrDPI;
}
export function mmToPx(value) {
	var inch = parseFloat(value) / 25.4;
	var c_value = parseFloat(inch) * getDPI()[0];
	//      console.log(c_value);
	return c_value;
}
